<template>
  <div class="is-flex my-2">
    <a @click="ownerPlus" class="button is-info" :class="{ 'is-outlined': !isPlusClick }">+</a>
    <a @click="ownerMinus" class="button is-info" :class="{ 'is-outlined': !isMinusClick }">-</a>
  </div>
</template>
<script>
export default {
  name: 'AlertPlusMinusButton',
  props: {
    payload: {
      type: Object
    }
  },
  data () {
    return {
      isPlusClick: false,
      isMinusClick: false
    }
  },
  methods: {
    ownerPlus () {
      this.$network_utils.updateAlert({
        id: this.payload.id,
        owner: 'NULL',
        status: 'active',
        minimum_permission: 6,
        maximum_permission: 'null'
      })
      this.isPlusClick = true
    },
    ownerMinus () {
      this.$network_utils.updateAlert({
        id: this.payload.id,
        owner: 'NULL',
        status: 'active',
        maximum_permission: 5,
        minimum_permission: 'null'
      })
      this.isMinusClick = true
    }
  }
}
</script>
